import React from 'react';

const API = '/api/v1';

export async function contentApi(path, { method = 'GET', body, signal } = {}) {
  const response = await fetch(API + path, {
    method,
    credentials: 'include',
    signal,
    headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || `Request failed (${response.status})`);
  return payload;
}

export function scopePath(scope) {
  return encodeURIComponent(scope || 'global');
}

export function ScopeBadge({ row }) {
  const label = row.scope === 'global' ? 'Global bank' : (row.organisation_name || 'Organisation bank');
  return React.createElement('span', { className: 'content-scope-badge' }, label);
}
